import { createApi } from '../createApi';
import * as dummy from '../dummy/inquiries';
import * as real from '../api/inquiries';

const api = createApi(dummy, real);

export const inquiryService = {
  /* 서비스 (유저용) */
  create: api.createInquiry,
  getMyList: api.getMyInquiries,
  getMyById: api.getMyInquiryById,

  /* 관리자 */
  adminGetList: api.getAdminInquiries,
  adminGetById: api.getAdminInquiryById,
  adminAnswer: api.answerAdminInquiry,
};
